import { AclAction } from 'shared/domains/apollo/generated/types';
export const excludeAnonymousUser = (user) => user.id !== 'anonymous-user';
export const isCompanyUserWithAccess = (user) => user.actions.includes(AclAction.Read);
export const isCompanyUserWithoutAccess = (user) => !user.actions.includes(AclAction.Read);
export const isExternalUserId = (id) => id.startsWith('email|');
export const isExternalUser = (user) => isExternalUserId(user.userId);
const isCompanyUserId = (id) => id.startsWith('auth0|');
export const isCompanyUser = (user) => isCompanyUserId(user.userId);
export const sortAlphabetically = (a, b) => a.name.localeCompare(b.name);
